import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { NavigationEnd, Router } from '@angular/router';

//interfaces
import { OrderInterface, OrderPreviewInterface } from '../shared/interfaces';

//helpers
import { OrderHelper } from '../shared/helpers';

//services
import { OrderService } from '../shared/services';

@Component({
  selector: 'app-layout',
  templateUrl: './layout.component.html',
  styleUrl: './layout.component.scss'
})
export class LayoutComponent implements OnInit, OnDestroy {

  public total: number = 0;
  public saved: number = 0;
  public employee: number = 0;
  public order: OrderPreviewInterface | null;
  public isEmployee: boolean = false;
  public showModal: boolean = false;
  public isLoading: boolean = false
  public currentRoute: String = '';

  private $order: Subscription;
  private $loading: Subscription;
  private $employee: Subscription;
  private $router: Subscription;

  constructor(
    private router: Router,
    private orderHelper: OrderHelper,
    private cdRef: ChangeDetectorRef
  ) {
    this.$router = this.router.events.subscribe((val) => {
      if (val instanceof NavigationEnd) {
        this.currentRoute = val.url;
        this.cdRef.detectChanges();
      }
    });
  }

  ngOnInit(): void {
    this.$order = OrderService.orderPreview.subscribe((val) => {
      this.order = val.order;
      this.calculateSum();
    })
    this.$loading = OrderService.loading.subscribe((val) => {
      this.isLoading = val;
    })
    this.$employee = OrderService.employee.subscribe((val) => {
      this.isEmployee = val;
      this.calculateSum();
    })
  }

  async calculateSum() {
    const calc = this.orderHelper.calculateSum()
    this.total = calc.total;
    this.saved = calc.saved;
    this.employee = calc.employee;
  }

  public continue() {
    if (this.currentRoute !== '/basket') {
      this.router.navigate(['/basket'])
      return
    }
    if (this.order && this.order.itemList.length && !this.isLoading) {
      this.router.navigate(['/control'])
    } else {
      this.showModal = true;
    }
  }

  ngOnDestroy(): void {
    this.$order.unsubscribe();
    this.$employee.unsubscribe();
    this.$loading.unsubscribe();
    this.$router.unsubscribe();
  }

}
